<template>
  <div>
    <div>
      <el-descriptions border size="small" :column="2">
        <el-descriptions-item label="头像"> <img :src="userInfo.avatar" alt class="avatar" /></el-descriptions-item>
        <el-descriptions-item label=""><template slot="label">
          <i class="el-icon-user"></i>
          昵称
        </template>{{userInfo.nickname}}</el-descriptions-item>
        <el-descriptions-item label="手机号"> <template slot="label">
          <i class="el-icon-mobile-phone"></i>
          手机号
        </template>{{userInfo.mobile}}</el-descriptions-item>
        <el-descriptions-item label="等级">{{userInfo.levelName}}</el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{userInfo.name}}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{userInfo.createTime}}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div>
      <user-tag :accountId="id">
      </user-tag>
    </div>
    <div>
      <div class="title">
        证书
      </div>
      <el-tabs  type="border-card">
        <el-tab-pane v-for="userCert in userCerts" :label="userCert.name">
          <el-descriptions border size="mini" :column="2">
            <el-descriptions-item label="等级">{{Math.floor(userCert.growthPoint / 500) + 1}}</el-descriptions-item>
            <el-descriptions-item label="总经验值">{{userCert.growthPoint}}</el-descriptions-item>
            <el-descriptions-item label="当前等级进度"><el-progress type="dashboard" :percentage="(userCert.growthPoint % 500) / 5"  :color="colors"></el-progress></el-descriptions-item>
            <el-descriptions-item label="证书创建时间">{{userCert.createTime}}</el-descriptions-item>
          </el-descriptions>
          <UserAttrs :user-cert-id="userCert.id"></UserAttrs>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

</template>

<script>
import { getAccountInfo, getUserCerts } from '@/api/demo/user'
import UserAttrs from '@/components/users/userAttrs'
import UserTag from '@/components/users/userTags'
export default {
  name: 'userInfo',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    UserTag,
    UserAttrs
  },
  watch: {
    id (newValue, oldValue) {
      this.getUserInfo()
      this.getUserCert()
    }
  },
  data () {
    return {
      userInfo: {},
      userCerts: [],
      colors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 }
      ]
    }
  },
  mounted () {
    this.getUserInfo()
    this.getUserCert()
  },
  methods: {
    getUserInfo () {
      console.log('this.id', this.id)
      getAccountInfo(this.id).then(res => {
        this.userInfo = res
      })
    },
    getUserCert () {
      getUserCerts({ accountId: this.id }).then(res => {
        this.userCerts = res
      })
    }
  }
}
</script>

<style scoped>
.avatar{
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.title{
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
